import UserView from "components/UserView/userView"
import React, { useEffect, useContext } from "react"
import AuthContext from "context/auth/authContext"
import { RecordPageView } from "App"
import { Helmet } from "react-helmet-async"
import { HelveticaBold, PoppinsNormal } from "common/typographies"
import i18n from "i18n"
import { Container } from "reactstrap"
import { CircularProgress } from "@mui/material"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { TEAM } from "constants/entitlements"

const Teams = () => {
  RecordPageView()
  const authContext = useContext(AuthContext)
  const {
    user,
    getUser,
    getOrganization,
    getActualUser,
    organization,
    internalUser,
  } = authContext

  useEffect(() => {
    if (!user) {
      getUser()
    } else {
      getOrganization({
        organizationId: user["custom:organizationId"],
      })
    }
  }, [user])

  return (
    <EntitlementPageGuard permission={TEAM}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper - Equipo</title>
        </Helmet>
        <Container fluid>
          {user && !organization.loading ? (
            <UserView user={user} />
          ) : (
            <Container
              fluid
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 154px)",
              }}
            >
              <CircularProgress />
            </Container>
          )}
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}
export default Teams
